import { Link } from "react-router-dom";

const footerLinks = {
  collections: [
    { label: "i-clothes", href: "/collections/clothes" },
    { label: "i-shoes", href: "/collections/shoes" },
    { label: "i-bag", href: "/collections/bags" },
    { label: "New Arrivals", href: "/collections/new-arrivals" },
    { label: "The Glow Edit", href: "/pages/the-glow-edit" },
  ],
  info: [
    { label: "About i-if", href: "/pages/about" },
    { label: "Size Guide", href: "/pages/size-guide" },
    { label: "Track Your Order", href: "/order-tracking" },
    { label: "Shipping & Delivery", href: "/pages/shipping" },
    { label: "Returns & Exchanges", href: "/pages/returns" },
    { label: "Privacy Policy", href: "/pages/privacy" },
  ],
};

const socials = [
  { icon: "ri-instagram-line", href: "https://instagram.com", label: "Instagram" },
  { icon: "ri-pinterest-line", href: "https://pinterest.com", label: "Pinterest" },
  { icon: "ri-tiktok-line", href: "https://tiktok.com", label: "TikTok" },
  { icon: "ri-facebook-circle-line", href: "https://facebook.com", label: "Facebook" },
];

export default function Footer() {
  return (
    <footer className="bg-midnight text-moonlight/80" style={{ fontFamily: "'Jost', sans-serif" }}>
      {/* Top Section */}
      <div className="px-6 lg:px-16 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/11f299ce572862a7443fa4f5e7dec340/39eaa7af49292fe352c32005f65aa55b.png"
              alt="i-if"
              className="h-9 w-auto object-contain mb-5 brightness-200"
            />
            <p className="text-sm leading-relaxed text-moonlight/60 max-w-xs mb-6">
              <em style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1rem", color: "#E8E6E3" }}>
                "I illuminate fashion."
              </em>
              <br />
              We believe every woman carries her own light. Our role is simply to give it a surface to shine from.
            </p>
            <div className="flex items-center gap-4">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-pearl/20 text-moonlight/50 hover:text-moonlight hover:border-pearl/50 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Collections */}
          <div>
            <h4 className="text-xs tracking-widest uppercase text-pearl/60 mb-5">Collections</h4>
            <ul className="space-y-3">
              {footerLinks.collections.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-moonlight/60 hover:text-moonlight transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs tracking-widest uppercase text-pearl/60 mb-5">Information</h4>
            <ul className="space-y-3">
              {footerLinks.info.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-moonlight/60 hover:text-moonlight transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 pt-5 border-t border-pearl/10">
              <p className="text-xs text-moonlight/40 mb-1">Customer Care</p>
              <a
                href="mailto:hello@i-if.com"
                className="text-sm text-moonlight/60 hover:text-moonlight transition-colors cursor-pointer"
              >
                hello@i-if.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="border-t border-pearl/10 px-6 lg:px-16 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-moonlight/30">
          <p>© 2026 i-if. All rights reserved. Free returns within 30 days.</p>
          <div className="flex items-center gap-4">
            <span>🔒 Secure Checkout</span>
            <span>PayPal</span>
            <span>Visa / Mastercard</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
